// import '@fortawesome/fontawesome-free'
import bsn from 'bootstrap.native/dist/bootstrap-native-v4'
import AOS from 'aos';
import './pattern'
import ScrollPosStyler from 'scrollpos-styler';
//require('./lib/mailchimp');
import zenscroll from 'zenscroll';
import picturefill from 'picturefill'
import objectFitImages from 'object-fit-images';

var collapseMenu = document.getElementById('navbarMenu');
var nav = document.getElementsByTagName('body')[0]

collapseMenu.addEventListener('show.bs.collapse', function(event){
  nav.classList.add("menu-shown");
})

collapseMenu.addEventListener('hide.bs.collapse', function(event){
  nav.classList.remove("menu-shown");
})

AOS.init();

// Rotating banner logic
(function initRotatingBanner() {
  const banners = document.querySelectorAll('.rotating-banner-item');
  if (banners.length <= 1) return;

  let currentIndex = 0;
  const rotationInterval = 5000; // 5 seconds

  setInterval(() => {
    banners[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % banners.length;
    banners[currentIndex].classList.add('active');
  }, rotationInterval);
})();

var defaultDuration = 500 // ms
var edgeOffset = 80 // px
zenscroll.setup(defaultDuration, edgeOffset)

objectFitImages('img.is-cover');

const handleEskFormSubmission = async (form, event) => {
  event.preventDefault();
  event.stopPropagation();

  const submitButton = document.getElementById('eskFormSubmit');
  submitButton.classList.add('d-none');

  const formData = new FormData(form);
  const jsonData = {};

  formData.forEach((value, key) => {
    jsonData[key] = value;
  });

  try {
    const response = await fetch('/.netlify/functions/esk-form', {
      method: 'POST',
      body: JSON.stringify(jsonData),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Ops... Something went wrong');
    }

    const responseData = await response.json();
    const content = document.getElementById('esk-card-body');
    content.innerHTML = `
      <div class="alert alert-success">
        <h6>
          Thank you for requesting the EventStorming starter kit.
          <br />
          You will receive an email containing all the materials in a few moments.
        </h6>
      </div>
    `;
  } catch (error) {
    console.error('Error:', error);
    const content = document.getElementById('esk-card-body');
    content.innerHTML = `
      <div class="alert alert-danger">
        <h6>
          Ops... Something went wrong.
        </h6>
        <p>
          Write to <a href="mailto:info@eventstorming.com">info@eventstorming.com</a> if the issue persists.
        </p>
      </div>
    `;
  }
};

// EventStorming starterkit
window.addEventListener('load', function() {
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.getElementsByClassName('needs-validation');

  // Loop over them and prevent submission
  var validation = Array.prototype.filter.call(forms, function(form) {
    form.addEventListener('submit', function(event) {
      const isValid = form.checkValidity();
      form.classList.add('was-validated');

      if (isValid) {
        if (form.id === 'eskForm') { handleEskFormSubmission(form, event); }
      } else {
        event.preventDefault();
        event.stopPropagation();
      }
    }, false);
  });
}, false);




// WEBPACK FOOTER //
// /opt/build/repo/assets/js/app.jsx